import Api from 'api/v2/Api';
import axios from 'axios';

export class TranslationRuleApiClass extends Api {
  fetch(directoryType, id) {
    const url = `/api/v2/${directoryType}s/${id}/translationrules?limit=100`;

    return this
      .initialize()
      .then(() => axios.get(url).then(resp => (resp && resp.data) || []));
  }

  create(directoryType, id, rule, direction, ruleType = 'builtIn') {
    const url = `/api/v2/${directoryType}s/${id}/translationrules`;

    return this
      .initialize()
      .then(() => axios.post(url, { [ruleType]: rule, direction })
        .then(resp => (resp && resp.data) || {}));
  }

  delete(directoryType, id, attributeId) {
    const url = `/api/v2/${directoryType}s/${id}/translationrules/${attributeId}`;

    return this
      .initialize()
      .then(() => axios.delete(url));
  }
}

export default new TranslationRuleApiClass();
